var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-medical-devices-control',{attrs:{"role":_vm.role}})
}
var staticRenderFns = []

export { render, staticRenderFns }